/**
 * ExplorationLimitTooltip.jsx - Shows exploration limit breakdown and tech bonuses
 */

import React from 'react';

export function ExplorationLimitTooltip({
  explorationBonusInfo,
  onClose
}) {
  const { baseLimit, unlocked, locked, totalBonus, maxPossible } = explorationBonusInfo;

  return (
    <div className="wm-explore-tooltip" style={{ maxHeight: '400px', overflowY: 'auto', width: '280px' }}>
      <div className="wm-tooltip-header">
        <span className="wm-tooltip-title">Exploration Limit</span>
        <button className="wm-tooltip-close" onClick={onClose}>x</button>
      </div>
      <div className="wm-tooltip-body" style={{ padding: '8px 12px' }}>
        <div style={{ marginBottom: '12px', padding: '8px', background: 'rgba(0,0,0,0.2)', borderRadius: '6px', fontSize: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
            <span style={{ color: '#a0a0a0' }}>Base limit:</span>
            <span style={{ color: '#d0d0d0' }}>{baseLimit}</span>
          </div>
          {totalBonus > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
              <span style={{ color: '#70c070' }}>Tech bonuses:</span>
              <span style={{ color: '#90e090' }}>+{totalBonus}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '4px', marginTop: '4px' }}>
            <span style={{ fontWeight: 'bold', color: '#e0d0b0' }}>Current limit:</span>
            <span style={{ fontWeight: 'bold', color: '#ffd080' }}>{baseLimit + totalBonus}</span>
          </div>
        </div>

        {unlocked.length > 0 && (
          <div style={{ marginBottom: '12px' }}>
            <div style={{ fontSize: '11px', color: '#70c070', marginBottom: '6px', fontWeight: 'bold' }}>UNLOCKED</div>
            {unlocked.map(tech => (
              <div key={tech.techId} style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 6px', background: 'rgba(100,180,100,0.15)', borderRadius: '4px', marginBottom: '3px', fontSize: '12px' }}>
                <span><span style={{ marginRight: '4px' }}>{tech.icon}</span>{tech.name}</span>
                <span style={{ color: '#90e090' }}>+{tech.bonus}</span>
              </div>
            ))}
          </div>
        )}

        {locked.length > 0 && (
          <div>
            <div style={{ fontSize: '11px', color: '#a0a0a0', marginBottom: '6px', fontWeight: 'bold' }}>RESEARCH TO UNLOCK</div>
            {locked.map(tech => (
              <div key={tech.techId} style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 6px', background: 'rgba(100,100,100,0.15)', borderRadius: '4px', marginBottom: '3px', fontSize: '12px', opacity: 0.7 }}>
                <span><span style={{ marginRight: '4px' }}>{tech.icon}</span>{tech.name}</span>
                <span style={{ color: '#808080' }}>+{tech.bonus}</span>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: '10px', fontSize: '11px', color: '#707070', textAlign: 'center' }}>
          Max possible: {maxPossible} tiles
        </div>
      </div>
    </div>
  );
}

export default ExplorationLimitTooltip;
